import { parserClickTrackData, spmReport } from '@/utils/report'
import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import queryString from 'query-string'
import { isArray, isFunction } from '..'

const trackPv = obj => {
  const { from, to, params = {}, meta } = obj

  const { logAuto } = meta

  if (logAuto && logAuto.pv) {
    const clickFrom = parserClickTrackData(logAuto.source)

    if (clickFrom) {
      params.click_from = clickFrom
    }

    spmReport.reportPagePv(from.fullPath, { source: logAuto.source, ...params, ...getPvReportCustomData(to.fullPath, logAuto.reportQuery) }, to.fullPath)
  }
}

const trackPvEnd = obj => {
  const { from, to, params = {}, meta } = obj

  const { logAuto } = meta

  if (!logAuto || !logAuto.pv || !logAuto.duration) return

  const mixParams = {
    ...params,
    ...getPvReportCustomData(from.fullPath, logAuto.reportQuery)
  }

  trackPv({
    from,
    to,
    params: mixParams,
    meta
  })
}

const getPvReportCustomData = (queryStr, reportQuery) => {
  let queryData = {}

  if (reportQuery) {
    const parsedQuery = queryString.parseUrl(queryStr)

    if (isFunction(reportQuery)) {
      queryData = reportQuery(parsedQuery.query)
    } else if (isArray(reportQuery)) {
      reportQuery.forEach(item => {
        queryData[item] = parsedQuery.query[item]
      })
    }
  }

  return queryData
}

const pageTimeMap = {}

export function usePageView(router) {
  try {
    let startTime = 0 // 进入页面的时间
    let leaveTime = 0 // 离开页面的时间

    if (!router) {
      return
    }

    const handleRouteEnter = (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      trackPv({
        from,
        to,
        meta: to.meta
      })

      pageTimeMap[to.path] = new Date().getTime()
      next()
    }

    const handleRouteLeave = (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
      leaveTime = new Date().getTime()
      trackPvEnd({
        from,
        to,
        meta: from.meta || {},
        params: {
          duration: leaveTime - pageTimeMap[from.path]
        }
      })

      delete pageTimeMap[from.path]
    }

    router.beforeEach(handleRouteEnter)
    router.afterEach(handleRouteLeave)
  } catch (error) {
    console.error(error)
  }
}
